import React, { useState, useEffect } from 'react';

import CreateBundleTemplate from '../../templates/CreateBundleTemplate';
import createBundle from '../../services/createBundle.service';
import { useClientContext } from '../../../../contexts/ClientContext';

const handleCheck = (value, itemList, setItemList, overrideCheck, disable = false) => {
  const index = itemList.findIndex((item) => item.value === value);
  const listCopy = itemList.slice();

  if (overrideCheck !== undefined) {
    listCopy[index].isChecked = overrideCheck;
  } else {
    listCopy[index].isChecked = !listCopy[index].isChecked;
  }

  if (disable) {
    listCopy[index].isDisabled = !listCopy[index].isDisabled;
  }

  setItemList(listCopy);

  return listCopy[index].isChecked;
};

const resetCheck = (itemList, setItemList) => {
  const listCopy = itemList.map((assessment) => ({
    ...assessment,
    isChecked: false,
    isDisabled: false,
  }));
  setItemList(listCopy);
};

const checkError = async (data) => {
  let error;
  if (!data.client.contactPreference) {
    error = 'Contact Preference is required.';
  } else if (data.client.contactPreference === 'email' && !data.client.email) {
    error = 'Email address is required';
  } else if (data.documents.length > 0 && !data.client.email) {
    error = 'Email address is required for sending client document';
  } else if (data.client.contactPreference === 'phone' && !data.client.phone) {
    error = 'Phone number is required';
  } else if (data.documents.length === 0
    && data.assessments.length === 0
    && data.releaseOfInformation.length === 0) {
    error = 'At least one form is required.';
  } else if
  (data.releaseOfInformation.filter((release) => !release.customFields.roiContactId).length > 0) {
    error = 'ROI contact is required.';
  } else {
    error = '';
  }

  return Promise.resolve(error);
};

const CreateBundle = () => {
  const client = useClientContext();

  const [isDisabled, setIsDisabled] = useState(true);
  useEffect(() => {
    setIsDisabled(!client.client.valid);
  }, [client.client.valid]);

  const [verbalRoiContact, setVerbalRoiContact] = useState();
  const [roiContact, setRoiContact] = useState();

  const [assessmentList, setAssessmentList] = useState([]);
  useEffect(() => {
    setAssessmentList([
      {
        label: 'Registration',
        value: 'registration',
        id: 'registration',
        isChecked: false,
        isDisabled: false,
      },
      {
        label: 'Annual Screening',
        value: 'annual_screen',
        id: 'annual_screen',
        isChecked: false,
        isDisabled: false,
      },
      {
        label: 'Cage Aid',
        value: 'cageaid',
        id: 'cageaid',
        isChecked: false,
        isDisabled: false,
      },
      {
        label: 'Gad7',
        value: 'gad7',
        id: 'gad7',
        isChecked: false,
        isDisabled: false,
      },
      {
        label: 'LEC-5',
        value: 'lec5',
        id: 'lec5',
        isChecked: false,
        isDisabled: false,
      },
      {
        label: 'Nutrition Screening',
        value: 'nutriscreen',
        id: 'nutriscreen',
        isChecked: false,
        isDisabled: false,
      },
      {
        label: 'PHQ-9',
        value: 'phq9',
        id: 'phq9',
        isChecked: false,
        isDisabled: false,
      },
      {
        label: 'PHQ-9A',
        value: 'phq9a',
        id: 'phq9a',
        isChecked: false,
        isDisabled: false,
      },
      {
        label: 'Pre-Psych Eval',
        value: 'prepsycheval',
        id: 'prepsycheval',
        isChecked: false,
        isDisabled: false,
      },
      {
        label: 'SDOH',
        value: 'sdoh',
        id: 'sdoh',
        isChecked: false,
        isDisabled: false,
      },
      {
        label: 'Triage Risk Assessment',
        value: 'triage',
        id: 'triage',
        isChecked: false,
        isDisabled: false,
      },

    ]);
  }, []);

  const [formList, setFormList] = useState([{
    label: 'Change Provider/Therapist Request',
    value: 'providerchange',
    id: 'form0',
    isChecked: false,
    isDisabled: false,
  },
  {
    label: 'Form Completion Request',
    value: 'formcomplete',
    id: 'form1',
    isChecked: false,
    isDisabled: false,
  }]);

  const [releaseOfInformationList, setReleaseOfInformationList] = useState([
    {
      label: 'ROI Discuss',
      value: 'verbalroi',
      id: 'verbalroi',
      isChecked: false,
      isDisabled: false,
    },
    {
      label: 'ROI Medical Records',
      value: 'roi',
      id: 'roi',
      isChecked: false,
      isDisabled: false,
    }]);

  const [documentList, setDocumentList] = useState([]);
  useEffect(() => {
    setDocumentList([
      {
        label: 'Benefit Summary',
        value: 'benefitsum',
        id: 'document0',
        isChecked: false,
      },
      {
        label: 'Consent to Treat',
        value: 'consenttx',
        id: 'document1',
        isChecked: false,
      },
      {
        label: 'No Show Policy',
        value: 'noshow',
        id: 'document2',
        isChecked: false,
      },
      {
        label: 'Sliding Fee Scale',
        value: 'slidingfee',
        id: 'document3',
        isChecked: false,
      },
    ]);
  }, []);

  const [hasDocumentAssigned, setHasDocumentAssigned] = useState(false);
  const [hasVerbalRoiChecked, setHasVerbalRoiChecked] = useState(false);

  const handleAssessmentChange = (e) => {
    const { value } = e.target;

    const isChecked = handleCheck(value, assessmentList, setAssessmentList);

    if (value === 'registration') {
      handleCheck('nutriscreen', assessmentList, setAssessmentList, isChecked, true);
      handleCheck('consenttx', documentList, setDocumentList, isChecked, true);
      handleCheck('noshow', documentList, setDocumentList, isChecked, true);
      if (documentList.filter((document) => document.isChecked).length > 0) {
        setHasDocumentAssigned(true);
      } else {
        setHasDocumentAssigned(false);
      }
    }

    if (value === 'annual_screen') {
      handleCheck('nutriscreen', assessmentList, setAssessmentList, isChecked, true);
    }
  };

  const handleFormChange = (e) => {
    const { value } = e.target;
    handleCheck(value, formList, setFormList);
  };

  const handleRoiChange = (e) => {
    const { value } = e.target;
    handleCheck(value, releaseOfInformationList, setReleaseOfInformationList);
  };

  const handleDocumentListChange = (e) => {
    const { value } = e.target;
    handleCheck(value, documentList, setDocumentList);

    if (documentList.filter((document) => document.isChecked).length > 0) {
      setHasDocumentAssigned(true);
    } else {
      setHasDocumentAssigned(false);
    }
  };

  const [wasSuccess, setWasSuccess] = useState(false);
  const [wasFailure, setWasFailure] = useState(false);
  const [error, setError] = useState('');

  const handleClick = async () => {
    console.log(roiContact);
    const data = {
      client: client.client,
      clientId: client.clientId,
      assessments: [...assessmentList.filter((assessment) => assessment.isChecked)
        .map((assessment) => assessment.value),
      ...formList.filter((form) => form.isChecked).map((form) => form.value)],
      documents: documentList.filter((document) => document.isChecked)
        .map((document) => ({
          clientName: `${client.client.firstName} ${client.client.lastName}`,
          email: client.client.email,
          code: document.value,
          customFields: {
            clientName: `${client.client.firstName} ${client.client.lastName}`,
            medicaidId: client.mcdId,
            clientId: client.clientId,
          },
        })),
      releaseOfInformation: releaseOfInformationList.filter((release) => release.isChecked)
        .map((release) => ({
          clientName: `${client.client.firstName} ${client.client.lastName}`,
          email: client.client.email,
          code: release.value,
          customFields: {
            clientName: `${client.client.firstName} ${client.client.lastName}`,
            medicaidId: client.mcdId,
            clientId: client.clientId,
            roiContactId: release.id === 'verbalroi' ? verbalRoiContact : roiContact,
          },
        })),
    };

    setWasSuccess(false);
    setWasFailure(false);
    const errorMsg = await checkError(data);
    setError(errorMsg);

    if (errorMsg) {
      setWasFailure(true);
    } else {
      createBundle(data).then(
        (res) => {
          console.log(res);
          setWasSuccess(true);
          client.clearClient();
          resetCheck(assessmentList, setAssessmentList);
          resetCheck(documentList, setDocumentList);
          setHasVerbalRoiChecked(false);
          setVerbalRoiContact(undefined);
        },
      ).catch((err) => {
        console.debug(err);
        if (err.response.status === 400) {
          console.log(err.response.data);
          setError(err.response.data.errors.join('<br>'));
        } else {
          setError('An error occurred while creating form bundle');
        }
        setWasFailure(true);
      });
    }
  };

  return (
    <CreateBundleTemplate
      contact={client.client}
      setContact={client.setClient}
      setVerbalRoiContact={setVerbalRoiContact}
      assessmentSelect={{
        sectionName: 'Assessments',
        itemList: assessmentList,
        onChange: handleAssessmentChange,
      }}
      documentSelect={{
        sectionName: 'Documents',
        itemList: documentList,
        onChange: handleDocumentListChange,
      }}
      formSelect={{
        sectionName: 'Forms',
        itemList: formList,
        onChange: handleFormChange,
      }}
      roiSelect={{
        sectionName: 'Release of Information',
        itemList: releaseOfInformationList,
        onChange: handleRoiChange,
      }}
      disabled={isDisabled}
      handleClick={handleClick}
      hasDocumentAssigned={hasDocumentAssigned}
      hasVerbalRoiChecked={hasVerbalRoiChecked}
      wasSuccess={wasSuccess}
      wasFailure={wasFailure}
      error={error}
      verbalRoiContacts={client.verbalRoiContacts}
      roiContacts={client.roiContacts}
      setRoiContact={setRoiContact}
    />
  );
};

export default CreateBundle;
